export function toLocalISO(isoString: string): string {
	const date = new Date(isoString);
	const offset = date.getTimezoneOffset() * 60000;
	return new Date(date.getTime() - offset).toISOString().slice(0, -1);
}
